import {
  LOGOUT, SET_LOADING, GET_NOTIFICATION_SUCCESS, GET_NOTIFICATION_FAILURE
} from './types';

const initialState = {
  notificaciones: [],
  isLoading: false,
  error: null,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notificaciones: action.payload,
        error: null,

      };
    case GET_NOTIFICATION_FAILURE:
      return {
        ...state,
        notificaciones: null,
        isLoading: false,
        error: action.payload.response.data.error,
      };
    case SET_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default notificationReducer;
